import { serviceDisclaimer } from "../lib/constants";

export function Disclaimer({ compact = false }: { compact?: boolean }) {
  return (
    <aside
      className={`rounded-lg border border-gold/40 bg-[#fff8ec] text-charcoal ${
        compact ? "p-4 text-sm" : "p-5 text-base"
      }`}
    >
      <strong className="mb-2 block text-gold">تنبيه نطاق الخدمة</strong>
      <p className="m-0 leading-8">{serviceDisclaimer}</p>
    </aside>
  );
}
